const { NS } = require( '../../../config' );

const addNS = ( string ) => {
    return `${ NS }-${ string }`;
};

const Classes = {
    APP: addNS( 'app-root' ),

    APP_HEADER: addNS( 'app-header' ),
    APP_HEADER_LOGO: addNS( 'app-header-logo' ),
    APP_HEADER_MAINMENU: addNS( 'app-header-mainmenu' ),
    APP_HEADER_USER: addNS( 'app-header-user' ),

    APP_MAIN_CONTENT: addNS( 'app-main-content' ),

    APP_FOOTER: addNS( 'app-footer' ),
    APP_FOOTER_MENU: addNS( 'app-footer-menu' ),
    APP_FOOTER_COPYRIGHT: addNS( 'app-footer-copyright' )
};

module.exports = {
    NS,
    Classes
};
